import styled from 'styled-components';

interface Props {
  actual: any;
}

export const Container = styled.ul`
  display: flex;
  flex-direction: row;
  position: relative;
  width: 100%;
  padding: 4px 4px 0;
  border-bottom: 2px solid #e1e1e1;
  list-style: none;
`;

export const Tab = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;

  &:hover > button.close {
    visibility: visible;
    opacity: 1;
  }
`;

export const TabButton = styled.button<Props>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing200};
  font-weight: 600;
  font-size: 16px;
  border-radius: 8px 8px 0px 0px;
  border: none;
  transition: background-color 0.2s;
  overflow: hidden;
  color: #ff6511;
  background-color: white;
  padding: 10px;



  ${({ actual }) =>
    actual
      ? `
    &::after {
      content: '';
      position: absolute;
      right: 0;
      bottom: -2px;
      left: 0;
      height: 2px;
      background-color: #ff6511;
    }
  `
      : `
    font-weight: 400;
    color: #a1a1a1;
  `}
`;

export const AddTabButton = styled(TabButton)`
  padding: 12px 16px !important;
  background-color: rgba(225, 225, 225, 0.5) !important;
  box-shadow: none !important;
`;

export const CloseTabButton = styled.button<Props>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  margin: auto 0;
  right: 6px;
  height: fit-content;
  padding: 2px;
  visibility: hidden;
  opacity: 0;
  transition: opacity 100ms linear;
  background-color: #a1a1a1;
  border-radius: 100px;

  &:hover {
    color: #a1a1a1;
    background-color: ${({ theme }) => theme.themeSecondary};
  }

  ${({ actual }) =>
    !actual &&
    `
    background-color: #d0d0d0;
  `}
`;
